import ActionConstants from "../action-constants"
import Action from "./Action";

class CartListModelActions extends Action {
    static getModelData(data) {
        return {
            type: ActionConstants.GET_MODEL_NAME,
            payload: {
                data
            }
        }
    }
}

export default CartListModelActions;